"use strict";

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactThreeFiber = require("react-three-fiber");
var _reactInfiniteScroller = _interopRequireDefault(require("react-infinite-scroller"));
var _utils = require("../utils");
var _GLTFView = _interopRequireDefault(require("./GLTFView"));
var _AzertyKeyboardBatibouw = _interopRequireDefault(require("./AzertyKeyboardBatibouw"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function PlanCellHozizontal(_ref) {
  var fetchData = _ref.fetchData,
    hasMore = _ref.hasMore,
    items = _ref.items,
    search = _ref.search,
    setSearch = _ref.setSearch,
    viewMore = _ref.viewMore,
    cell = _ref.cell,
    verifyCatIsInside = _ref.verifyCatIsInside,
    page = _ref.page,
    _ref$uriTransformer = _ref.uriTransformer,
    uriTransformer = _ref$uriTransformer === void 0 ? function (u) {
      return u;
    } : _ref$uriTransformer,
    intl = _ref.intl,
    defaultLanguage = _ref.defaultLanguage,
    project = _ref.project,
    logEvent = _ref.logEvent,
    setCatSelected = _ref.setCatSelected,
    catSelected = _ref.catSelected,
    expos = _ref.expos,
    uri = _ref.uri,
    font = _ref.font,
    selected = _ref.selected,
    setSelected = _ref.setSelected,
    setShowOptions = _ref.setShowOptions,
    showOptions = _ref.showOptions,
    placeholder = _ref.placeholder,
    categories = _ref.categories,
    all = _ref.all,
    hallLabel = _ref.hallLabel,
    closeText = _ref.closeText;
  var inputRef = (0, _react.useRef)(null);
  var keyboardRef = (0, _react.useRef)(null);
  var _ref2 = (0, _react.useState)(null),
    _ref3 = _slicedToArray(_ref2, 2),
    currentDetailExpo = _ref3[0],
    setCurrentDetailExpo = _ref3[1];
  var _ref4 = (0, _react.useState)(false),
    _ref5 = _slicedToArray(_ref4, 2),
    showKeyboard = _ref5[0],
    setShowKeyboard = _ref5[1];
  var itemRefs = (0, _react.useRef)({});
  var listRef = (0, _react.useRef)(null);
  var selectionSourceRef = (0, _react.useRef)(null); // 'map' | 'list'
  var _ref6 = (0, _react.useState)(false),
    _ref7 = _slicedToArray(_ref6, 2),
    planLoaded = _ref7[0],
    setPlanLoaded = _ref7[1];
  var _ref8 = (0, _react.useState)(0),
    _ref9 = _slicedToArray(_ref8, 2),
    progress = _ref9[0],
    setProgress = _ref9[1];
  var _ref0 = (0, _react.useState)(search),
    _ref1 = _slicedToArray(_ref0, 2),
    debouncedSearch = _ref1[0],
    setDebouncedSearch = _ref1[1];
  (0, _react.useEffect)(function () {
    var timer = setTimeout(function () {
      setDebouncedSearch(search);
    }, 1500);
    return function () {
      return clearTimeout(timer);
    };
  }, [search]);
  var normalizeString = function normalizeString(str) {
    return str.normalize('NFD') // décompose les caractères accentués
    .replace(/[\u0300-\u036f]/g, '') // retire les accents
    .toLowerCase();
  }; // passe tout en minuscules

  var RESET_DELAY = 10000;
  (0, _react.useEffect)(function () {
    if (!search) return;
    var timer = setTimeout(function () {
      setSearch(""); // reset la valeur

      // 🔹 scroll automatiquement vers l'exposant sélectionné si un est choisi
      if (selected && selected.length === 1) {
        var expoId = selected[0].id;
        var itemRef = itemRefs.current[expoId];
        var listEl = listRef.current;
        if (itemRef !== null && itemRef !== void 0 && itemRef.current && listEl) {
          setTimeout(function () {
            var itemTop = itemRef.current.offsetTop;
            var itemHeight = itemRef.current.offsetHeight;
            var listHeight = listEl.clientHeight;
            listEl.scrollTo({
              top: itemTop - listHeight / 2 + itemHeight / 2,
              behavior: 'smooth'
            });
          }, 50); // petit délai pour que le DOM soit mis à jour
        }
      }
    }, RESET_DELAY);
    return function () {
      return clearTimeout(timer);
    };
  }, [search, selected]);
  (0, _react.useEffect)(function () {
    if (planLoaded) {
      setProgress(100);
      return;
    }
    var interval = setInterval(function () {
      setProgress(function (prev) {
        return prev < 90 ? prev + 4 : prev;
      });
    }, 200);
    return function () {
      return clearInterval(interval);
    };
  }, [planLoaded]);

  // console.log(font)
  // console.log(cell.text_form_color)
  // console.log(intl)
  // console.log(defaultLanguage)
  (0, _react.useEffect)(function () {
    if (!showKeyboard) return;
    var handleClickOutside = function handleClickOutside(event) {
      if (inputRef.current && keyboardRef.current && !inputRef.current.contains(event.target) && !keyboardRef.current.contains(event.target)) {
        setShowKeyboard(false);
        // Dé-focus l'input
        inputRef.current.blur();
      }
    };
    document.addEventListener('touchstart', handleClickOutside);
    return function () {
      return document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [showKeyboard]);
  (0, _react.useEffect)(function () {
    if (!selected || selected.length !== 1) return; // rien à faire si pas de sélection

    var expoId = selected[0].id;
    var itemRef = itemRefs.current[expoId];
    var listEl = listRef.current;
    if (!(itemRef !== null && itemRef !== void 0 && itemRef.current) || !listEl) return;

    // Fonction pour centrer l'élément dans la liste
    var scrollToItem = function scrollToItem() {
      var itemTop = itemRef.current.offsetTop;
      var itemHeight = itemRef.current.offsetHeight;
      var listHeight = listEl.clientHeight;
      listEl.scrollTo({
        top: itemTop - listHeight / 2 + itemHeight / 2,
        behavior: 'smooth'
      });
    };

    // ✅ Si le menu catégories est ouvert → scroll immédiat
    if (showOptions) {
      requestAnimationFrame(scrollToItem);
    } else {
      // ✅ Petit délai pour que le DOM se mette à jour après reset ou recherche
      setTimeout(scrollToItem, 100);
    }

    // 🔹 Optionnel : si tu veux t'assurer que le détail s'affiche
    // seulement si la sélection vient de la liste ou de la map
    if (selectionSourceRef.current === 'list' || selectionSourceRef.current === 'map') {
      setCurrentDetailExpo(selected[0]);
    }
  }, [selected, showOptions, items, search]); // ✅ dépendances correctes

  (0, _react.useEffect)(function () {
    if (showKeyboard) {
      setCurrentDetailExpo(null); // ferme la pop-up des exposants
    }
  }, [showKeyboard]);
  var filteredItems = _react.default.useMemo(function () {
    var normalizedSearch = normalizeString(debouncedSearch || '');
    return items.filter(function (expo) {
      var expoName = (0, _utils.i18nData)(expo, 'expo_name', intl, defaultLanguage) || expo.expo_name;
      var matchSearch = !normalizedSearch || normalizeString(expoName).includes(normalizedSearch) || normalizeString(expo.expo_number).includes(normalizedSearch);
      var matchCategory = !catSelected || verifyCatIsInside(intl, defaultLanguage, expo.categories, catSelected);
      return matchSearch && matchCategory;
    });
  }, [items, debouncedSearch, catSelected, intl, defaultLanguage]);
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: '100%',
      width: '100%',
      fontFamily: font
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      height: '100%',
      position: 'relative',
      marginTop: '1em'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flex: 1.4,
      background: '#0000000F',
      backdropFilter: 'blur(2.5rem)',
      // 40px → 2.5rem
      // WebkitBackdropFilter: 'blur(2.5rem)',
      position: 'fixed',
      zIndex: 10,
      marginTop: '1.25rem',
      // 20px
      marginLeft: '1.25rem',
      // 20px
      borderRadius: '1.25rem',
      // 20px
      padding: '0.4em',
      maxHeight: '80vh',
      width: '14%',
      minWidth: '12rem',
      // sécurité responsive
      overflow: 'hidden',
      // ❌ PAS DE SCROLL ICI
      display: 'grid',
      gridTemplateRows: showOptions ? 'auto auto 1fr' : 'auto 0fr 1fr',
      transition: 'grid-template-rows 0.1s ease'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      zIndex: 20,
      marginBottom: '0.4em'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    onClick: function onClick() {
      return setShowOptions(function (prev) {
        return !prev;
      });
    },
    style: {
      fontFamily: font,
      fontSize: '0.7em',
      border: '0.125rem solid ' + cell.color_text_right,
      // 2px
      borderRadius: '1.875rem',
      // 30px
      color: cell.color_text_right,
      display: 'grid',
      gridTemplateColumns: '7fr 1fr',
      padding: '0.4em',
      alignItems: 'center',
      marginLeft: '1em',
      marginRight: '1em',
      marginTop: '1em'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: cell.color_text_right,
      marginLeft: '1em'
    }
  }, catSelected.length >= 10 ? catSelected.slice(0, 10) + '...' : catSelected || all), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("svg", {
    fill: cell.color_text_right,
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: showOptions ? 'rotate(180deg)' : 'rotate(0deg)',
      transition: 'transform 0.25s ease'
    }
  }, /*#__PURE__*/_react.default.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/_react.default.createElement("g", {
    "data-name": "arrow-ios-downward"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    opacity: "0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 16a1 1 0 0 1-.64-.23l-6-5a1 1 0 1 1 1.28-1.54L12 13.71l5.36-4.32a1 1 0 0 1 1.41.15 1 1 0 0 1-.14 1.46l-6 4.83A1 1 0 0 1 12 16z"
  }))))))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      overflowY: 'auto',
      // 🔹 active le scroll vertical
      maxHeight: '80vh',
      opacity: showOptions ? 1 : 0,
      transition: 'opacity 0.25s ease',
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    onClick: function onClick() {
      setCatSelected('');
      setSelected([]);
      setShowOptions(false);
    },
    style: {
      padding: '0.8em',
      cursor: 'pointer',
      borderBottom: '0.0625rem solid ' + cell.text_form_color,
      // 1px
      color: cell.text_form_color,
      fontSize: '0.75rem' // 15px
    }
  }, all), categories.map(function (category) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: category,
      onClick: function onClick() {
        setCatSelected(category);
        setSelected([]);
        setShowOptions(false);
      },
      style: {
        padding: '0.8em',
        cursor: 'pointer',
        borderBottom: '0.0625rem solid ' + cell.text_form_color,
        color: cell.text_form_color,
        fontSize: '0.75rem',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'left'
      }
    }, category);
  })), /*#__PURE__*/_react.default.createElement("style", null, "\n        .scrollableDiv::-webkit-scrollbar {\n          width: 0.75rem; /* 12px */\n        }\n        .scrollableDiv::-webkit-scrollbar-thumb {\n          background-color: rgba(0,0,0,0.5);\n          border-radius: 0.375rem; /* 6px */\n        }\n        "), /*#__PURE__*/_react.default.createElement("div", {
    ref: listRef,
    className: "scrollableDiv",
    style: {
      overflowY: 'auto',
      flex: 1,
      WebkitOverflowScrolling: 'touch',
      overscrollBehavior: 'contain',
      paddingRight: '0.2em',
      boxSizing: 'border-box',
      maxHeight: '80vh'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactInfiniteScroller.default, {
    pageStart: 0,
    loadMore: fetchData,
    hasMore: hasMore,
    loader: /*#__PURE__*/_react.default.createElement("h2", {
      key: 0
    }, "Loading..."),
    useWindow: false
  }, filteredItems.map(function (expo, index) {
    if (!itemRefs.current[expo.id]) {
      itemRefs.current[expo.id] = /*#__PURE__*/_react.default.createRef();
    }
    var expoName = (0, _utils.i18nData)(expo, 'expo_name', intl, defaultLanguage) || expo.expo_name;
    var isSelected = selected && selected.some(function (sel) {
      return sel.id === expo.id;
    });
    var expoNameColor = isSelected ? '#FBFBFBFB' : cell.text_form_color;
    var prevItem = index > 0 ? filteredItems[index - 1] : null;
    var prevIsSelected = prevItem && selected && selected.some(function (sel) {
      return sel.id === prevItem.id;
    });
    var scrollToExpo = function scrollToExpo(expoId) {
      var ref = itemRefs.current[expoId];
      if (ref && ref.current && listRef.current) {
        var itemTop = ref.current.offsetTop;
        var itemHeight = ref.current.offsetHeight;
        var listHeight = listRef.current.clientHeight;
        listRef.current.scrollTo({
          top: itemTop - listHeight / 2 + itemHeight / 2,
          behavior: 'smooth'
        });
      }
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      key: expo.id,
      ref: itemRefs.current[expo.id],
      style: {
        padding: isSelected ? '0.6em' : '0.4em',
        // marginTop: prevIsSelected ? '0.8em' : (isSelected ? '0.5em' : '0.3em'),
        backgroundColor: isSelected ? cell.btn_select_color || 'transparent' : 'transparent',
        borderRadius: isSelected ? '1.875rem' : '0',
        // 30px
        marginBottom: isSelected ? '0.125rem' : '0',
        // 2px
        borderBottom: '0.0625rem solid ' + cell.text_form_color // 1px
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      onClick: function onClick() {
        selectionSourceRef.current = 'list';
        setCurrentDetailExpo(expo);
        setSelected([expo]);
        scrollToExpo(expo.id);
        logEvent('click', {
          cellId: cell.id,
          pageId: page.id,
          languageCode: intl.locale,
          expoName: expo.expo_name,
          expoNumber: expo.expo_number
        });
      },
      style: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.4em'
      }
    }, expo.logo_uri && /*#__PURE__*/_react.default.createElement("div", {
      style: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        borderRadius: '1.5em'
      }
      // backgroundColor: cell.background_color,
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '0.4em',
        paddingTop: '0.8em',
        paddingBottom: '0.8em'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        flex: '1 1 auto',
        minWidth: 0
      }
    }, /*#__PURE__*/_react.default.createElement("h1", {
      style: {
        color: expoNameColor,
        fontWeight: 'bold',
        fontSize: '0.65rem',
        // 13px
        margin: 0,
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        hyphens: 'auto'
      }
    }, expoName)), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        flexShrink: 0,
        flexWrap: 'nowrap'
      }
    }, /*#__PURE__*/_react.default.createElement("h2", {
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: cell.color_text_left,
        fontWeight: 'bold',
        fontSize: '0.55rem',
        // 12px
        background: cell.background_btn_left,
        padding: '0.8em 1em',
        borderTopLeftRadius: '1.9375rem',
        // 31px
        borderBottomLeftRadius: '1.9375rem',
        borderTop: '0.0625rem solid ' + (isSelected ? cell.background_btn_right : cell.background_btn_left),
        borderLeft: '0.0625rem solid ' + (isSelected ? cell.background_btn_right : cell.background_btn_left),
        borderBottom: '0.0625rem solid ' + (isSelected ? cell.background_btn_right : cell.background_btn_left),
        // borderRight: '1px solid ' + cell.background_btn_left,
        whiteSpace: 'nowrap'
      }
    }, expo.expo_number), /*#__PURE__*/_react.default.createElement("span", {
      // onClick={(e) => {
      //   e.stopPropagation();
      //   setCurrentDetailExpo(expo);
      // }}
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '0.55rem',
        // 12px
        backgroundColor: cell.background_btn_right,
        color: cell.color_text_right,
        borderTopRightRadius: '1.9375rem',
        // 31px
        borderBottomRightRadius: '1.9375rem',
        borderTop: '0.0625rem solid ' + (isSelected ? cell.background_btn_right : cell.background_btn_left),
        borderRight: '0.0625rem solid ' + (isSelected ? cell.background_btn_right : cell.background_btn_left),
        borderBottom: '0.0625rem solid ' + (isSelected ? cell.background_btn_right : cell.background_btn_left),
        // borderLeft: '1px solid ' + cell.background_btn_left,
        padding: '0.8em 1em',
        cursor: 'pointer',
        whiteSpace: 'nowrap'
      }
    }, viewMore)))));
  }

  // return null;
  )))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flex: 8.7,
      position: 'relative',
      height: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      right: '2em',
      zIndex: 50
    }
  }, /*#__PURE__*/_react.default.createElement("input", {
    ref: inputRef,
    type: "search",
    placeholder: placeholder,
    value: search,
    readOnly: true,
    inputMode: "none",
    onMouseDown: function onMouseDown(e) {
      return e.preventDefault();
    },
    onClick: function onClick() {
      return setShowKeyboard(true);
    },
    style: {
      width: '16rem',
      // 260px
      padding: '1em 2.5em 1em 1em',
      borderRadius: '1.875rem',
      // 30px
      border: '0.0625rem solid ' + cell.border_form_color,
      // 1px
      backgroundColor: '#fff',
      fontFamily: font,
      fontSize: '0.75rem' // 15px
    }
  }), /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      position: 'absolute',
      right: '0.75rem',
      // 12px
      top: '50%',
      transform: 'translateY(-50%)',
      width: '1.25rem',
      // 20px
      height: '1.25rem',
      // 20px
      pointerEvents: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "80",
    cy: "80",
    r: "60",
    fill: "none",
    stroke: "#000000",
    strokeWidth: "0.5rem" // 8px
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "130",
    y1: "130",
    x2: "170",
    y2: "170",
    stroke: "#000000",
    strokeWidth: "0.75rem" // 12px
    ,

    strokeLinecap: "round"
  }))), !planLoaded && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      zIndex: 40,
      background: '#ffffffdd',
      backdropFilter: 'blur(0.375rem)',
      // 6px
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      pointerEvents: 'all'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '20rem',
      textAlign: 'center'
    }
  }, " ", /*#__PURE__*/_react.default.createElement("p", {
    style: {
      marginBottom: '0.875rem',
      // 14px
      fontSize: '0.9375rem',
      // 15px
      fontWeight: 600,
      color: '#000000',
      fontFamily: font,
      letterSpacing: '0.01875rem' // 0.3px
    }
  }, progress < 50 ? 'Preparing plan…' : 'Almost there…'), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%',
      height: '0.5rem',
      // 8px
      background: '#e5e5e5',
      borderRadius: '62.4375rem',
      // 999px
      overflow: 'hidden'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: "".concat(progress, "%"),
      height: '100%',
      background: cell.btn_select_color || '#6b4eff',
      transition: 'width 0.3s ease'
    }
  })))), /*#__PURE__*/_react.default.createElement(_reactThreeFiber.Canvas, {
    gl: {
      antialias: true
    },
    style: {
      height: '100%',
      width: '100%',
      filter: 'saturate(100%)'
    }
  }, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: null
  }, /*#__PURE__*/_react.default.createElement(_GLTFView.default, {
    setCatSelected: setCatSelected,
    expos: expos,
    currentCategory: catSelected,
    intl: intl,
    logEvent: logEvent,
    page: page,
    uriTransformer: uriTransformer,
    uri: uri,
    expoSelected: selected,
    colorSelected: cell.btn_select_color,
    cell: cell,
    setSelected: setSelected,
    selectionSourceRef: selectionSourceRef,
    onLoad: function onLoad() {
      return setPlanLoaded(true);
    }
  }))))), showKeyboard && /*#__PURE__*/_react.default.createElement(_AzertyKeyboardBatibouw.default, {
    input: search,
    setInput: setSearch,
    project: project,
    setVisible: setShowKeyboard,
    anchorRef: inputRef
  }), currentDetailExpo && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'fixed',
      top: 0,
      right: 0,
      height: '70%',
      width: '17%',
      backgroundColor: '#0000000F',
      backdropFilter: 'blur(2.5rem)',
      // 40px
      zIndex: 100,
      padding: '1em',
      borderRadius: '1rem',
      // 16px
      marginRight: '1em',
      marginTop: '4.8em',
      overflowY: 'auto',
      boxShadow: '-1em 0 2em rgba(0,0,0,0.3)',
      display: 'flex',
      flexDirection: 'column',
      gap: '0.8em'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.4em'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '5rem',
      // 80px
      height: '5rem',
      // 80px
      borderRadius: '0.6em',
      backgroundColor: '#0000000F',
      flexShrink: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, currentDetailExpo.logo_uri && /*#__PURE__*/_react.default.createElement("img", {
    src: uriTransformer(currentDetailExpo.logo_uri),
    alt: (0, _utils.i18nData)(currentDetailExpo, 'expo_name', intl, defaultLanguage),
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      borderRadius: '0.6em',
      imageRendering: 'auto'
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.4em'
    }
  }, /*#__PURE__*/_react.default.createElement("h1", {
    style: {
      color: cell.background_btn_left,
      fontSize: '0.95rem',
      // 18px
      marginTop: '0.3em',
      padding: '0.3em'
    }
  }, (0, _utils.i18nData)(currentDetailExpo, 'expo_name', intl, defaultLanguage)), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      textAlign: 'center',
      justifyContent: 'center',
      marginTop: '0.2em'
    }
  }, currentDetailExpo.expo_hall && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0.7em 0.9em',
      fontSize: '0.75rem',
      // 12px
      borderTopLeftRadius: '62.4375rem',
      // 999px
      borderBottomLeftRadius: '62.4375rem',
      background: cell.background_btn_left,
      color: cell.color_text_left,
      minWidth: 'auto',
      whiteSpace: 'nowrap'
    }
  }, hallLabel, " ", currentDetailExpo.expo_hall), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0.7em 0.9em',
      fontSize: '0.75rem',
      borderTopRightRadius: '62.4375rem',
      borderBottomRightRadius: '62.4375rem',
      background: cell.background_btn_right,
      color: cell.color_text_right,
      minWidth: 'auto',
      whiteSpace: 'nowrap'
    }
  }, currentDetailExpo.expo_number)))), currentDetailExpo.categories.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: cell.text_form_color,
      fontSize: '0.75rem',
      // 15px
      display: 'flex',
      flexWrap: 'wrap',
      gap: '0.4em'
    }
  }, currentDetailExpo.categories.map(function (cat, idx) {
    return /*#__PURE__*/_react.default.createElement("span", {
      key: idx,
      style: {
        color: cell.color_text_right,
        fontSize: '0.75rem',
        padding: '0.5em 1em',
        borderRadius: '62.4375rem',
        border: '0.125rem solid ' + cell.background_btn_left // 2px
      }
    }, (0, _utils.i18nData)(cat, 'name', intl, defaultLanguage));
  })), currentDetailExpo.description && /*#__PURE__*/_react.default.createElement("p", {
    style: {
      color: cell.text_form_color,
      fontSize: '0.75em'
    }
  }, (0, _utils.i18nData)(currentDetailExpo, 'description', intl, defaultLanguage)), currentDetailExpo.website_uri && /*#__PURE__*/_react.default.createElement("p", {
    style: {
      color: '#000000',
      fontSize: '0.75rem',
      marginTop: 'auto'
    }
  }, "Website:", ' ', /*#__PURE__*/_react.default.createElement("p", {
    style: {
      color: '#000000',
      textDecoration: 'underline'
    }
  }, currentDetailExpo.website_uri)), /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick() {
      return setCurrentDetailExpo(null);
    },
    style: {
      fontFamily: font,
      marginTop: 'auto',
      padding: '0.5em 2em',
      color: '#000000',
      borderRadius: '624.9375rem',
      // 9999px
      border: '0.0625rem solid #959595',
      // 1px
      fontSize: '0.75rem',
      // 12px
      cursor: 'pointer',
      alignSelf: 'center',
      backgroundColor: '#0000000F',
      backdropFilter: 'blur(2.5rem)'
    }
  }, closeText)));
}
var _default = exports.default = PlanCellHozizontal;